import React from 'react';
import BaseProps from "../../types/BaseProps";
import BaseWidget from "../widgets/base-widget/BaseWidget";
import classNames from 'classnames';
import {Controlled as CodeMirror} from 'react-codemirror2';
import 'codemirror/mode/yaml/yaml';

// Enable folding on indentation (for YAML syntax)
import 'codemirror/addon/fold/foldgutter';
import 'codemirror/addon/fold/indent-fold';
import 'codemirror/addon/fold/foldgutter.css';
// Enable find and replace
import 'codemirror/addon/search/search';
import 'codemirror/addon/search/searchcursor';
import 'codemirror/addon/search/jump-to-line';
import 'codemirror/addon/dialog/dialog';
import 'codemirror/addon/dialog/dialog.css';
// Enable commenting selected lines
import 'codemirror/addon/comment/comment';
// Enable highlighting of the active line
import 'codemirror/addon/selection/active-line';

import './SchemaEditor.scss';

type SchemaEditorProps = BaseProps & {
  value: string
  onChange: (value: string) => void
  hasErrors?: boolean
  hasWarnings?: boolean
};

class SchemaEditor extends React.Component<SchemaEditorProps> {

  private updateValue(value: string) {
    this.props.onChange(value);
  }

  render() {
    return (
      <BaseWidget className={classNames('SchemaEditor', this.props.className)}
                  hasErrors={this.props.hasErrors}
                  hasWarnings={this.props.hasWarnings}>
        <CodeMirror
          value={this.props.value}
          options={{
            mode: 'yaml',
            lineNumbers: true,
            foldGutter: true,
            lineWrapping: true,
            styleActiveLine: true,
            gutters: ["CodeMirror-linenumbers", "CodeMirror-foldgutter"],
            // TODO: add shortcuts info (like in gdb)
            extraKeys: {
              "Ctrl-F": "findPersistent",
              'Cmd-/': 'toggleComment',
              'Ctrl-/': 'toggleComment'
            }
          }}
          onBeforeChange={(editor, data, value) => {
            this.updateValue(value);
          }}
          onChange={() => {
          }}
        />
      </BaseWidget>
    );
  }

}

export default SchemaEditor;
